/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusProfileDto } from '../../models/lexplus-profile-dto';
import { LexplusUpdateProfileDto } from '../../models/lexplus-update-profile-dto';

export interface AuthenticationControllerUpdateProfileV1$Params {
      body: LexplusUpdateProfileDto
}

export function authenticationControllerUpdateProfileV1(http: HttpClient, rootUrl: string, params: AuthenticationControllerUpdateProfileV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusProfileDto>> {
  const rb = new RequestBuilder(rootUrl, authenticationControllerUpdateProfileV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusProfileDto>;
    })
  );
}

authenticationControllerUpdateProfileV1.PATH = '/v1/authentication/profile';
